module.exports = __webpack_public_path__ + "img/ArmadoConAutoprotector.7f936263.svg";